<template>
    <div class="subsidiary">
        <div class="left">
            <img class="leftimg" src="../assets/img/home_Rd_bg1.png" alt="">
            <img  class="leftimg1" :src="list[listindex].src" alt="">
        </div>
        <div class="subsidiaryContent">
            <ul class="subsidiaryHeader">
                <li v-for="(item, index) in list" :key="index" :class="{ 'active': listindex == index }"
                    @click="listindex = index">
                    <div>{{ item.title }}</div>
                    <div>{{ item.text }}</div>
                </li>
            </ul>
            <ul class="subsidiaryLi">
                <li v-for="(item, index) in  list[listindex].li" :key="index">
                    {{ item }}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: [
                {
                    title: '集团旗下子公司',
                    text: 'Subsidiaries of the Group',
                    li: [
                        '厦门欧帛新材料科技有限公司',
                        '匠油网科技(厦门)有限公司',
                        '福建炬诚新材料科技有限公司',
                        '江苏油典新材料科技有限公司',
                        '重庆油典新材料科技有限公司',
                        '山西油典新材料科技有限公司',
                    ],
                    src: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/aboutme_img3.png'
                }, {
                    title: '油品生产基地',
                    text: 'Oil production base',
                    li: [
                        '厦 门 生产基地',
                        '漳 州 生产基地',
                        '重 庆 生产基地',
                        '南 通 生产基地（预计2025年二季度投产）',
                    ],
                    src: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/aboutme_img3.1.png'
                },
                {
                    title: '公司产品',
                    text: 'Company products',
                    li: [
                        '水性加工液系列',
                        '工业润滑油系列',
                        '油性加工油系列',
                        '加工油液复合剂系列',
                        '成型油系列',
                        '单剂原料',
                    ],
                    src: 'https://jyw-image.oss-cn-shenzhen.aliyuncs.com/homepage/aboutme_img3.2.png'
                }
            ],
            listindex: 0
        }
    },
}
</script>
<style scoped>
.subsidiary {
    height: 1080px;
    padding: 101px 0 101px 415px;
    position: relative;
}

.subsidiaryContent {
    background: #fff;
    width: 100%;
    height: 100%;
    padding-left: 467px;
    padding-top: 127px;
}

.subsidiaryHeader {
    /* display: flex; */
    //width: 933px;
    position: absolute;
    right: 106px;
}

.subsidiaryHeader::after {
    content: ' ';
    display: inline-block;
    position: absolute;
    bottom: 0;
    width: 933px;
    height: 3px;
    background: #E0E0E0;
    border-radius: 0px 0px 0px 0px;
    left: 0;
}

.subsidiaryHeader>li {
    height: 100px;
    display: inline-block;
    margin-right: 106px;
    position: relative;
    cursor: pointer;
}

.subsidiaryHeader>li:last-child {
    margin-right: 0;
}

.subsidiaryHeader>li>div:first-child {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 32px;
    color: #6B6B6B;
    line-height: 38px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.subsidiaryHeader .active>div:first-child {
    color: #373737;
}

.subsidiaryHeader .active::after {
    content: " ";
    display: inline-block;
    width: 256px;
    height: 11px;
    background: linear-gradient(180deg, #45AFFF 0%, #61FF53 100%);
    border-radius: 0px 0px 0px 0px;
    position: absolute;
    bottom: 0px;
    z-index: 1;
}

.subsidiaryHeader>li>div:last-child {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #989898;
    line-height: 28px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.subsidiaryLi {
    position: absolute;
    top: 439px;
    right: 250px;
    width: 764px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #373737;
    line-height: 51px;
    letter-spacing: 4px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.subsidiaryLi>li {
    position: relative;
}

.subsidiaryLi>li::before {
    display: inline-block;
    position: absolute;
    content: ' ';
    width: 9px;
    height: 9px;
    background: #45AFFF;
    border-radius: 50%;
    left: -25px;
    top: 50%;
    transform: translateY(-50%);
}

.left {
    width: 698px;
    height: 645px;
    background: #45AFFF;
    border-radius: 0px 323px 323px 0;
    top: 218px;
    position: absolute;
    left: 0;
}

.leftimg {
    width: 727px;
    height: 782px;
    position: absolute;
    left: 121px;
    top: -34px;
}
.leftimg1{
    width: 785px;
    height: 592px;
    left: 87px;
    top:49px;
    position: absolute;
    z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/subsidiary.vue